<template>
  <v-tab-item v-if="pageType">
    <slot name="image"></slot>

    <v-menu
      offset-y
      :key="booth._id"
      v-for="booth in booths"
      open-on-hover
      :close-delay="100"
    >
      <template v-slot:activator="{ on }">
        <div :class="classes(booth)" :style="style(booth)" v-on="on">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            :viewBox="`0 0 ${booth.width * 100} ${booth.height * 100}`"
          >
            <text
              :x="booth.width * 50"
              :y="booth.height * 50"
              :width="booth.width * 100"
              :height="booth.height * 100"
              :style="
                `font-size: ${getCalculatedFontSize(
                  booth
                )}px; text-anchor: middle; dominant-baseline: central; transform-origin: center;`
              "
              v-html="booth.title"
            />
          </svg>
        </div>
      </template>
      <v-card class="mx-auto" max-width="500" min-width="180">
        <v-card-text>
          <div class="overline mb-2 booth-card-free" v-if="booth.occupied == 0">
            {{ $t("view.free") }}
          </div>
          <div
            class="overline mb-2 booth-card-reserved"
            v-if="booth.occupied == 1"
          >
            {{ $t("view.reserved") }}
          </div>
          <div
            class="overline mb-2 booth-card-occupied"
            v-if="booth.occupied == 2"
          >
            {{ $t("view.occupied") }}
          </div>

          <p class="display-1 text--primary mb-0">{{ booth.title }}</p>

          <p class="text--primary">
            <template
              v-if="booth.category !== null && booth.category !== undefined"
            >
              {{ $t("form.category") + ": K " + booth.category }}
            </template>
            <template v-if="booth.size !== null && booth.size !== undefined">{{
              " (" + booth.size + "m²)"
            }}</template>
          </p>

          <div
            v-if="
              booth.notes !== null &&
                booth.notes !== undefined &&
                booth.notes !== ''
            "
          >
            <p>
              {{ $t("form.notes") + ":" }} <br />
              {{ booth.notes }}
            </p>
          </div>

          <div v-if="booth.occupied == 2">
            <p>
              {{ $t("view.alreadyOccupiedFrom") }}
              <a
                :href="booth.vendorUrl"
                target="_blank"
                rel="noopener"
                class="vendor-link"
              >
                {{ booth.vendorName }}
              </a>
              <span
                class="ml-1"
                v-for="additionalExhibitor in booth.additionalExhibitors || []"
                :key="additionalExhibitor.id"
              >
                <a
                  :href="additionalExhibitor.vendorUrl"
                  target="_blank"
                  rel="noopener"
                >
                  {{ additionalExhibitor.vendorName }}
                </a>
              </span>
            </p>
          </div>
        </v-card-text>

        <v-card-actions
          v-if="booth.occupied == 0 && !selectedBoothIds.includes(booth._id)"
        >
          <div class="text-uppercase cta-button bg-red">
            <a
              @click="
                addSelectedBoothId(booth._id);
                scrollToContactForm();
              "
              >{{ $t("view.reserve") }}</a
            >
          </div>
        </v-card-actions>
        <v-card-actions v-else-if="booth.occupied == 2">
          <div
            class="text-uppercase cta-button bg-red float-right"
            v-if="booth.user_id"
          >
            <a @click="currentExhibitorUserId = booth.user_id">{{
              $t("exhibitorData")
            }}</a>
          </div>
        </v-card-actions>
      </v-card>
    </v-menu>
    <VirtualExhibitionDialog :userId="currentExhibitorUserId" />
  </v-tab-item>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VirtualExhibitionDialog from "../VirtualExhibitionDialog.vue";
export default {
  props: ["booths"],
  components: {
    VirtualExhibitionDialog,
  },
  data: () => ({
    currentExhibitorUserId: null,
  }),
  methods: {
    ...mapActions(["addSelectedBoothId"]),

    absolute(value) {
      return Math.abs(value);
    },

    scrollToContactForm() {
      const element = document.getElementById("exhibition-contact-form");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },

    getCalculatedFontSize(booth) {
      const calculatedFontSize = Math.min(booth.width, booth.height) * 50;
      return Math.max(calculatedFontSize, 130);
    },

    classes(booth) {
      return {
        "exhibtion-booth": true,
        "exhibtion-booth-selected": this.selectedBoothIds.includes(booth._id),
        "exhibtion-booth-free":
          !this.selectedBoothIds.includes(booth._id) &&
          (booth.occupied == 0 ||
            booth.occupied == null ||
            booth.occupied == undefined),
        "exhibtion-booth-reserved": booth.occupied == 1,
        "exhibtion-booth-occupied": booth.occupied == 2,
      };
    },
    style(booth) {
      var position = {
        left: booth.x + "%",
        top: booth.y + "%",
        width: booth.width + "%",
        height: booth.height + "%",
        display: "flex",
        "justify-content": "center",
        "align-items": "center",
      };

      if (this.pageType === "ISRM" && booth.title == "PS6") {
        position["transform"] = "rotate(-60deg)";
      }

      if (booth.rotation) {
        position["transform"] = `rotate(${booth.rotation}deg)`;
      }

      return position;
    },
  },
  computed: {
    ...mapGetters(["pageType", "selectedBoothIds"]),
  },
};
</script>

<style lang="scss">
.exhibtion-booth {
  position: absolute;
  border-style: solid;
  border-width: 3%;

  &-free,
  &-selected {
    border-color: #1ca256;
    background-color: #1ca25644;
    z-index: 1;
  }

  &-selected {
    border-color: gray;
    background-color: lightgray;
  }

  &-occupied {
    border-color: #a21c26;
    background-color: #a21c2644;
    z-index: 3;
  }

  &-reserved {
    border-color: #ffc107;
    background-color: #ffc10744;
    z-index: 2;
  }
}

.booth-card {
  &-free {
    color: #1ca256;
  }

  &-occupied {
    color: #a21c26;
  }

  &-reserved {
    color: #ffc107;
  }
}

a.vendor-link {
  &:link {
    color: #a21c26 !important;
  }

  &:visited {
    color: #a21c26 !important;
  }

  &:hover {
    color: #a21c26 !important;
  }
}
</style>
